const LogoSingleColor = () => (
	<svg width={24} height={24} fill="none">
		<path
			fill="#fff"
			d="M6.615 14.723h1.748c1.235 0 1.9.666 1.9 1.9v.228c0 1.235-.666 1.9-1.9 1.9H3.899C2.664 18.75 2 18.084 2 16.85V6.9C2 5.664 2.665 5 3.9 5h.816c1.235 0 1.9.665 1.9 1.9v7.823ZM20.09 5h1.044c1.462 0 2.052.93 1.406 2.24l-3.856 7.957v1.653c0 1.235-.665 1.9-1.899 1.9h-.798c-1.235 0-1.9-.646-1.9-1.786v-1.766L10.27 7.241C9.644 5.912 10.214 5 11.676 5h.987c1.083 0 1.785.475 2.184 1.5l1.52 3.95 1.538-3.95c.399-1.006 1.101-1.5 2.184-1.5Z"
		/>
	</svg>
);
export default LogoSingleColor;
